import { Box, chakra, Flex } from "@chakra-ui/react";
import { CustomText } from "../common/components";

export const StyledNavbar = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    // bg: "green",
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: "gray.border",
    h: "72px",
    minH: "72px",
    px: "16px",
  },
});

export const StyledSidebar = chakra(Flex, {
  baseStyle: {
    borderRight: "1px solid",
    borderColor: "gray.border",
    flex: 1,
    padding: "16px",
    pos: "relative",
    flexDir: "column",
    justifyContent: "space-between",
    height: "100%",
    overflow: "auto",
    overflowX: "hidden",
  },
});

export const StyledItemsContainer = chakra(Flex, {
  baseStyle: {
    flexDir: "column",
  },
});

export const StyledOverviewColoredCard = chakra(Flex, {
  baseStyle: {
    flex: 1,
    minHeight: "464px",
    border: "1px solid",
    borderColor: "gray.border",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    gap: "16px",
  },
});

export const StyledRightbtn = chakra(Flex, {
  baseStyle: {
    width: "26px",
    height: "26px",
    borderBottomLeftRadius: "8px",
    border: "1px solid",
    borderColor: "gray.border",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "0px",
    right: "0px",
    cursor: "pointer",
    zIndex: 1,
    bgColor: "theme.bg.container",
  },
});

export const StyledAdminLayoutParent = chakra(Box, {
  baseStyle: {
    height: "100%",
    overflow: "auto",
    p: "16px",
  },
});

export const StyledActivityArea = chakra(Flex, {
  baseStyle: {
    maxW: { base: "100%", xl: "500px" },
    // minW: '500px',
    backgroundColor: "theme.bg.container",
    maxH: "100%",
    borderRadius: "16px",
    padding: "16px",
    border: "1px solid",
    borderColor: "gray.100",
    flexDirection: "column",
    gap: "16px",
    flex: 0.5,
  },
});

export const NormalText = chakra(CustomText, {
  baseStyle: {
    fontWeight: 500,
    fontSize: "16px",
    color: "#5C6670",
  },
});

export const NormalHeading = chakra(CustomText, {
  baseStyle: {
    fontWeight: 500,
    fontSize: "18px",
  },
});

export const Heading = chakra(CustomText, {
  baseStyle: {
    height: "50px",
    fontSize: "24px",
    fontWeight: 500,
    p: "4px 0px 16px 16px",
  },
});
